import React from 'react'
import { portfolioData } from '../../../data/portfolio';

const Banner = props => {
    const { home } = portfolioData;
    const { title, subtitle, tagline, techStack } = home;

    return (
        <header className="relative min-h-screen flex items-center justify-center bg-gray-900 overflow-hidden" id="welcome">
            {/* Background Overlay with Gradient */}
            <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-gray-900 to-black z-0"></div>

            {/* Animated Background Elements - Subtle */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0">
                <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-primary-900/20 rounded-full blur-3xl opacity-50 animate-pulse"></div>
                <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-purple-900/20 rounded-full blur-3xl opacity-50 animate-pulse" style={{ animationDelay: '2s' }}></div>
            </div>

            <div className="relative z-10 container mx-auto px-6 text-center">
                <div className="inline-block mb-4 px-4 py-1 rounded-full bg-white/5 border border-white/10 text-primary-400 text-sm font-medium tracking-wider uppercase backdrop-blur-sm">
                    Welcome to my portfolio
                </div>

                <h1 className='text-4xl md:text-6xl lg:text-7xl font-bold mb-6 font-display tracking-tight text-white'>
                    {title}
                    <span className='block mt-2 text-2xl md:text-3xl lg:text-4xl text-gray-400 font-light'>
                        | <span className='text-transparent bg-clip-text bg-gradient-to-r from-primary-400 to-indigo-400 font-semibold'>{subtitle}</span>
                    </span>
                </h1>

                <p className='text-lg md:text-xl text-gray-400 font-light max-w-2xl mx-auto leading-relaxed mb-10'>
                    {tagline}
                </p>

                {/* Tech Stack Visual Row */}
                <div className="flex flex-wrap justify-center items-center gap-8 mb-12 animate-fade-in-up">
                    {techStack.map((tech, index) => (
                        <div key={index} className="flex flex-col items-center gap-2 group">
                            <div className="p-3 rounded-2xl bg-white/5 border border-white/10 group-hover:bg-white/10 group-hover:border-primary-500/30 transition-all duration-300 transform group-hover:scale-110 shadow-lg group-hover:shadow-primary-500/20">
                                {tech.className ? (
                                    <i
                                        className={`${tech.className} text-3xl md:text-4xl text-gray-400 group-hover:text-primary-400 transition-colors duration-300`}
                                    ></i>
                                ) : (
                                    <svg
                                        className="w-8 h-8 md:w-10 md:h-10 text-gray-400 group-hover:text-primary-400 transition-colors duration-300"
                                        viewBox={tech.viewBox || "0 0 24 24"}
                                        fill="currentColor"
                                    >
                                        <path d={tech.icon} />
                                    </svg>
                                )}
                            </div>
                            <span className="text-xs font-medium text-gray-500 group-hover:text-gray-300 transition-colors duration-300">{tech.name}</span>
                        </div>
                    ))}
                </div>

                <div className="flex flex-col sm:flex-row justify-center gap-5">
                    <a
                        href="#contact"
                        className="px-8 py-4 rounded-full bg-primary-600 text-white font-semibold shadow-lg shadow-primary-500/20 hover:bg-primary-500 hover:scale-105 hover:shadow-primary-500/40 transition-all duration-300"
                    >
                        Get in Touch
                    </a>
                    <a
                        href="#experience"
                        className="px-8 py-4 rounded-full bg-white/5 backdrop-blur-sm border border-white/10 text-white font-semibold hover:bg-white/10 hover:border-white/20 hover:scale-105 transition-all duration-300"
                    >
                        View My Work
                    </a>
                </div>
            </div>

            {/* Fade to White Gradient at Bottom */}
            <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-gray-50 to-transparent pointer-events-none"></div>

            {/* Scroll Indicator */}
            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce text-gray-600 z-20">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                </svg>
            </div>
        </header>
    )
}

Banner.propTypes = {}

export default Banner
